// # services
import { auth } from "@/services";

(function (angular) {
  "use strict";

  angular.module("app").controller("myEventsController", myEventsController);

  myEventsController.$inject = [
    "eventsPayload",
    "EventsApi",
    "Events",
    "$rootScope",
    "$scope",
  ];

  function myEventsController(
    eventsPayload,
    EventsApi,
    Events,
    $rootScope,
    $scope,
  ) {
    var vm = this;

    // properties
    vm.permissionChecks = {
      canCreateEvents: auth.hasPermission("events.create"),
    };
    vm.isLoading = false;
    vm.events = eventsPayload;
    vm.filters = {
      is_parent: true,
      user_id: $rootScope.thisUser.id,
      page: 1,
    };
    vm.showingCalendar = false;

    // methods
    vm.getEvents = getEvents;
    vm.createEvent = createEvent;
    vm.editEvent = editEvent;

    $scope.toggleCalendar = function () {
      vm.showingCalendar = !vm.showingCalendar;
    };

    vm.getEvents();

    /**
     * Retrieves the user's events from the API
     * @return {void}
     */
    function getEvents() {
      EventsApi.get(
        vm.filters,
        function handleGetEventOrdersResponse(response) {
          vm.events = response;
          vm.isLoading = false;
        },
        function handleGetEventOrdersError() {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Shows the create event modal then refreshes events
     * @return {void}
     */
    function createEvent() {
      Events.create().result.then(function () {
        getEvents();
      });
    }

    /**
     * Shows the edit event modal the reloads events
     * @param  {int} eventId - ID of event to edit
     * @return {void}
     */
    function editEvent(eventId) {
      Events.edit(eventId).result.then(function () {
        getEvents();
      });
    }
  }
})(angular);
